import { isEmptyHTML } from '@/app/util/editor/editor';
import { LANGUAGES_CONTENT } from '@/app/data/model_constants';

const getters = {
  translationOrFallbackFor:
    (_state, { current_client, current_profile }) =>
    // eslint-disable-next-line complexity
    (model, field, language = null, { ignore_company_languages = false } = {}) => {
      if (_.isNil(model) || _.isNil(field)) return '';

      const language_requested = language ?? current_profile.attributes.language;
      // Patch (ENG-2431): announcements still author in all content languages, so they opt out of
      // the company-languages gate. Remove once ENG-1958 finishes the translation rollout.
      const company_languages = ignore_company_languages
        ? LANGUAGES_CONTENT
        : (current_client.attributes.languages ?? LANGUAGES_CONTENT);

      if (company_languages.includes(language_requested)) {
        const field_requested = _.get(model.attributes.translations, `${language_requested}.${field}`);
        if (!_.isNil(field_requested) && !isEmptyHTML(field_requested)) {
          return { fallback_translation: field_requested };
        }
      }

      const language_client = _.get(model.attributes.translations, `${current_client.attributes.language}.${field}`);
      if (!_.isNil(language_client) && !isEmptyHTML(language_client)) {
        return { fallback_translation: language_client, fallback_language: current_client.attributes.language };
      }

      const remaining_locales = _.filter(
        company_languages,
        (lang) => ![language_requested, current_client.attributes.language].includes(lang),
      );

      let fallback_translation = null;
      let fallback_language = null;
      let index = 0;
      while (_.isNil(fallback_translation) && index < remaining_locales.length) {
        const language = remaining_locales[index];
        const field_translation = _.get(model.attributes.translations, `${language}.${field}`);
        if (!_.isNil(field_translation) && !isEmptyHTML(field_translation)) {
          fallback_translation = field_translation;
          fallback_language = language;
        } else {
          index += 1;
        }
      }
      if (_.isNil(fallback_translation) && !language) {
        const field_direct = model.attributes[field];
        if (!_.isNil(field_direct) && !isEmptyHTML(field_direct)) {
          return { fallback_translation: field_direct };
        }
      }
      return { fallback_translation, fallback_language };
    },
};

export default {
  getters,
};
